/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../types/graphqlapi";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createGroupLf = /* GraphQL */ `mutation CreateGroupLf($input: GroupLfInput, $id: String) {
  createGroupLf(input: $input, id: $id) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateGroupLfMutationVariables,
  APITypes.CreateGroupLfMutation
>;
export const updateGroupLf = /* GraphQL */ `mutation UpdateGroupLf($input: GroupLfInput, $id: String) {
  updateGroupLf(input: $input, id: $id) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateGroupLfMutationVariables,
  APITypes.UpdateGroupLfMutation
>;
export const deleteGroupLf = /* GraphQL */ `mutation DeleteGroupLf($input: GroupLfInput, $id: String) {
  deleteGroupLf(input: $input, id: $id) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteGroupLfMutationVariables,
  APITypes.DeleteGroupLfMutation
>;
export const createUserLf = /* GraphQL */ `mutation CreateUserLf($input: UserLfInput, $id: String) {
  createUserLf(input: $input, id: $id) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserLfMutationVariables,
  APITypes.CreateUserLfMutation
>;
export const updateUserLf = /* GraphQL */ `mutation UpdateUserLf($input: UserLfInput, $id: String) {
  updateUserLf(input: $input, id: $id) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserLfMutationVariables,
  APITypes.UpdateUserLfMutation
>;
export const deleteUserLf = /* GraphQL */ `mutation DeleteUserLf($input: UserLfInput, $id: String) {
  deleteUserLf(input: $input, id: $id) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserLfMutationVariables,
  APITypes.DeleteUserLfMutation
>;
export const createModeratorChatTokenLf = /* GraphQL */ `mutation CreateModeratorChatTokenLf($input: ChatTokenLfInput) {
  createModeratorChatTokenLf(input: $input) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateModeratorChatTokenLfMutationVariables,
  APITypes.CreateModeratorChatTokenLfMutation
>;
export const createGroup = /* GraphQL */ `mutation CreateGroup(
  $input: CreateGroupInput!
  $condition: ModelGroupConditionInput
) {
  createGroup(input: $input, condition: $condition) {
    id
    name
    memo
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateGroupMutationVariables,
  APITypes.CreateGroupMutation
>;
export const updateGroup = /* GraphQL */ `mutation UpdateGroup(
  $input: UpdateGroupInput!
  $condition: ModelGroupConditionInput
) {
  updateGroup(input: $input, condition: $condition) {
    id
    name
    memo
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateGroupMutationVariables,
  APITypes.UpdateGroupMutation
>;
export const deleteGroup = /* GraphQL */ `mutation DeleteGroup(
  $input: DeleteGroupInput!
  $condition: ModelGroupConditionInput
) {
  deleteGroup(input: $input, condition: $condition) {
    id
    name
    memo
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteGroupMutationVariables,
  APITypes.DeleteGroupMutation
>;
export const createUser = /* GraphQL */ `mutation CreateUser(
  $input: CreateUserInput!
  $condition: ModelUserConditionInput
) {
  createUser(input: $input, condition: $condition) {
    id
    group_id
    name
    email
    role
    is_personal_data_handler
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const updateUser = /* GraphQL */ `mutation UpdateUser(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    id
    group_id
    name
    email
    role
    is_personal_data_handler
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserMutationVariables,
  APITypes.UpdateUserMutation
>;
export const deleteUser = /* GraphQL */ `mutation DeleteUser(
  $input: DeleteUserInput!
  $condition: ModelUserConditionInput
) {
  deleteUser(input: $input, condition: $condition) {
    id
    group_id
    name
    email
    role
    is_personal_data_handler
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserMutationVariables,
  APITypes.DeleteUserMutation
>;
export const createSubject = /* GraphQL */ `mutation CreateSubject(
  $input: CreateSubjectInput!
  $condition: ModelSubjectConditionInput
) {
  createSubject(input: $input, condition: $condition) {
    id
    group_id
    subject_seq
    subject_number
    subject_name
    subject_description
    subject_purpose
    interview_type
    start_date
    end_date
    input_expiration_date
    expiration_date
    main_user_id_group
    main_user_id_asmarq
    memo
    canceled
    finished
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSubjectMutationVariables,
  APITypes.CreateSubjectMutation
>;
export const updateSubject = /* GraphQL */ `mutation UpdateSubject(
  $input: UpdateSubjectInput!
  $condition: ModelSubjectConditionInput
) {
  updateSubject(input: $input, condition: $condition) {
    id
    group_id
    subject_seq
    subject_number
    subject_name
    subject_description
    subject_purpose
    interview_type
    start_date
    end_date
    input_expiration_date
    expiration_date
    main_user_id_group
    main_user_id_asmarq
    memo
    canceled
    finished
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSubjectMutationVariables,
  APITypes.UpdateSubjectMutation
>;
export const deleteSubject = /* GraphQL */ `mutation DeleteSubject(
  $input: DeleteSubjectInput!
  $condition: ModelSubjectConditionInput
) {
  deleteSubject(input: $input, condition: $condition) {
    id
    group_id
    subject_seq
    subject_number
    subject_name
    subject_description
    subject_purpose
    interview_type
    start_date
    end_date
    input_expiration_date
    expiration_date
    main_user_id_group
    main_user_id_asmarq
    memo
    canceled
    finished
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSubjectMutationVariables,
  APITypes.DeleteSubjectMutation
>;
export const createMarkedSubject = /* GraphQL */ `mutation CreateMarkedSubject(
  $input: CreateMarkedSubjectInput!
  $condition: ModelMarkedSubjectConditionInput
) {
  createMarkedSubject(input: $input, condition: $condition) {
    id
    user_id
    subject_id
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMarkedSubjectMutationVariables,
  APITypes.CreateMarkedSubjectMutation
>;
export const updateMarkedSubject = /* GraphQL */ `mutation UpdateMarkedSubject(
  $input: UpdateMarkedSubjectInput!
  $condition: ModelMarkedSubjectConditionInput
) {
  updateMarkedSubject(input: $input, condition: $condition) {
    id
    user_id
    subject_id
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMarkedSubjectMutationVariables,
  APITypes.UpdateMarkedSubjectMutation
>;
export const deleteMarkedSubject = /* GraphQL */ `mutation DeleteMarkedSubject(
  $input: DeleteMarkedSubjectInput!
  $condition: ModelMarkedSubjectConditionInput
) {
  deleteMarkedSubject(input: $input, condition: $condition) {
    id
    user_id
    subject_id
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMarkedSubjectMutationVariables,
  APITypes.DeleteMarkedSubjectMutation
>;
export const createInterview = /* GraphQL */ `mutation CreateInterview(
  $input: CreateInterviewInput!
  $condition: ModelInterviewConditionInput
) {
  createInterview(input: $input, condition: $condition) {
    id
    subject_id
    interview_seq
    interview_type
    scheduled_start_date
    scheduled_end_date
    scheduled_start_time
    scheduled_end_time
    actual_start_date
    actual_end_date
    actual_start_time
    actual_end_time
    canceled
    memo
    note
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateInterviewMutationVariables,
  APITypes.CreateInterviewMutation
>;
export const updateInterview = /* GraphQL */ `mutation UpdateInterview(
  $input: UpdateInterviewInput!
  $condition: ModelInterviewConditionInput
) {
  updateInterview(input: $input, condition: $condition) {
    id
    subject_id
    interview_seq
    interview_type
    scheduled_start_date
    scheduled_end_date
    scheduled_start_time
    scheduled_end_time
    actual_start_date
    actual_end_date
    actual_start_time
    actual_end_time
    canceled
    memo
    note
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateInterviewMutationVariables,
  APITypes.UpdateInterviewMutation
>;
export const deleteInterview = /* GraphQL */ `mutation DeleteInterview(
  $input: DeleteInterviewInput!
  $condition: ModelInterviewConditionInput
) {
  deleteInterview(input: $input, condition: $condition) {
    id
    subject_id
    interview_seq
    interview_type
    scheduled_start_date
    scheduled_end_date
    scheduled_start_time
    scheduled_end_time
    actual_start_date
    actual_end_date
    actual_start_time
    actual_end_time
    canceled
    memo
    note
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteInterviewMutationVariables,
  APITypes.DeleteInterviewMutation
>;
export const createFileResource = /* GraphQL */ `mutation CreateFileResource(
  $input: CreateFileResourceInput!
  $condition: ModelFileResourceConditionInput
) {
  createFileResource(input: $input, condition: $condition) {
    id
    subject_id
    sort_index
    file_name
    title
    type
    url
    description
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFileResourceMutationVariables,
  APITypes.CreateFileResourceMutation
>;
export const updateFileResource = /* GraphQL */ `mutation UpdateFileResource(
  $input: UpdateFileResourceInput!
  $condition: ModelFileResourceConditionInput
) {
  updateFileResource(input: $input, condition: $condition) {
    id
    subject_id
    sort_index
    file_name
    title
    type
    url
    description
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFileResourceMutationVariables,
  APITypes.UpdateFileResourceMutation
>;
export const deleteFileResource = /* GraphQL */ `mutation DeleteFileResource(
  $input: DeleteFileResourceInput!
  $condition: ModelFileResourceConditionInput
) {
  deleteFileResource(input: $input, condition: $condition) {
    id
    subject_id
    sort_index
    file_name
    title
    type
    url
    description
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFileResourceMutationVariables,
  APITypes.DeleteFileResourceMutation
>;
export const createScenario = /* GraphQL */ `mutation CreateScenario(
  $input: CreateScenarioInput!
  $condition: ModelScenarioConditionInput
) {
  createScenario(input: $input, condition: $condition) {
    id
    subject_id
    sort_index
    scenario_no
    template_no
    text
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateScenarioMutationVariables,
  APITypes.CreateScenarioMutation
>;
export const updateScenario = /* GraphQL */ `mutation UpdateScenario(
  $input: UpdateScenarioInput!
  $condition: ModelScenarioConditionInput
) {
  updateScenario(input: $input, condition: $condition) {
    id
    subject_id
    sort_index
    scenario_no
    template_no
    text
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateScenarioMutationVariables,
  APITypes.UpdateScenarioMutation
>;
export const deleteScenario = /* GraphQL */ `mutation DeleteScenario(
  $input: DeleteScenarioInput!
  $condition: ModelScenarioConditionInput
) {
  deleteScenario(input: $input, condition: $condition) {
    id
    subject_id
    sort_index
    scenario_no
    template_no
    text
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteScenarioMutationVariables,
  APITypes.DeleteScenarioMutation
>;
export const createMonitor = /* GraphQL */ `mutation CreateMonitor(
  $input: CreateMonitorInput!
  $condition: ModelMonitorConditionInput
) {
  createMonitor(input: $input, condition: $condition) {
    id
    subject_id
    ans_id
    classification
    member_id
    name
    sex
    age
    address
    marriage
    children
    job
    memo
    sort_index
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMonitorMutationVariables,
  APITypes.CreateMonitorMutation
>;
export const updateMonitor = /* GraphQL */ `mutation UpdateMonitor(
  $input: UpdateMonitorInput!
  $condition: ModelMonitorConditionInput
) {
  updateMonitor(input: $input, condition: $condition) {
    id
    subject_id
    ans_id
    classification
    member_id
    name
    sex
    age
    address
    marriage
    children
    job
    memo
    sort_index
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMonitorMutationVariables,
  APITypes.UpdateMonitorMutation
>;
export const deleteMonitor = /* GraphQL */ `mutation DeleteMonitor(
  $input: DeleteMonitorInput!
  $condition: ModelMonitorConditionInput
) {
  deleteMonitor(input: $input, condition: $condition) {
    id
    subject_id
    ans_id
    classification
    member_id
    name
    sex
    age
    address
    marriage
    children
    job
    memo
    sort_index
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMonitorMutationVariables,
  APITypes.DeleteMonitorMutation
>;
export const createMonitorAssign = /* GraphQL */ `mutation CreateMonitorAssign(
  $input: CreateMonitorAssignInput!
  $condition: ModelMonitorAssignConditionInput
) {
  createMonitorAssign(input: $input, condition: $condition) {
    id
    subject_id
    monitor_id
    interview_id
    pin
    last_entry_date
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMonitorAssignMutationVariables,
  APITypes.CreateMonitorAssignMutation
>;
export const updateMonitorAssign = /* GraphQL */ `mutation UpdateMonitorAssign(
  $input: UpdateMonitorAssignInput!
  $condition: ModelMonitorAssignConditionInput
) {
  updateMonitorAssign(input: $input, condition: $condition) {
    id
    subject_id
    monitor_id
    interview_id
    pin
    last_entry_date
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMonitorAssignMutationVariables,
  APITypes.UpdateMonitorAssignMutation
>;
export const deleteMonitorAssign = /* GraphQL */ `mutation DeleteMonitorAssign(
  $input: DeleteMonitorAssignInput!
  $condition: ModelMonitorAssignConditionInput
) {
  deleteMonitorAssign(input: $input, condition: $condition) {
    id
    subject_id
    monitor_id
    interview_id
    pin
    last_entry_date
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMonitorAssignMutationVariables,
  APITypes.DeleteMonitorAssignMutation
>;
export const createMonitorAttribute = /* GraphQL */ `mutation CreateMonitorAttribute(
  $input: CreateMonitorAttributeInput!
  $condition: ModelMonitorAttributeConditionInput
) {
  createMonitorAttribute(input: $input, condition: $condition) {
    id
    subject_id
    monitor_id
    seq_no
    name
    value
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMonitorAttributeMutationVariables,
  APITypes.CreateMonitorAttributeMutation
>;
export const updateMonitorAttribute = /* GraphQL */ `mutation UpdateMonitorAttribute(
  $input: UpdateMonitorAttributeInput!
  $condition: ModelMonitorAttributeConditionInput
) {
  updateMonitorAttribute(input: $input, condition: $condition) {
    id
    subject_id
    monitor_id
    seq_no
    name
    value
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMonitorAttributeMutationVariables,
  APITypes.UpdateMonitorAttributeMutation
>;
export const deleteMonitorAttribute = /* GraphQL */ `mutation DeleteMonitorAttribute(
  $input: DeleteMonitorAttributeInput!
  $condition: ModelMonitorAttributeConditionInput
) {
  deleteMonitorAttribute(input: $input, condition: $condition) {
    id
    subject_id
    monitor_id
    seq_no
    name
    value
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMonitorAttributeMutationVariables,
  APITypes.DeleteMonitorAttributeMutation
>;
export const createMonitorCheckResult = /* GraphQL */ `mutation CreateMonitorCheckResult(
  $input: CreateMonitorCheckResultInput!
  $condition: ModelMonitorCheckResultConditionInput
) {
  createMonitorCheckResult(input: $input, condition: $condition) {
    id
    monitor_id
    subject_id
    interview_id
    initial_name
    initial_sex
    initial_age
    initial_address
    initial_marriage
    initial_children
    initial_job
    monitor_check_result_type
    submitted_text
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMonitorCheckResultMutationVariables,
  APITypes.CreateMonitorCheckResultMutation
>;
export const updateMonitorCheckResult = /* GraphQL */ `mutation UpdateMonitorCheckResult(
  $input: UpdateMonitorCheckResultInput!
  $condition: ModelMonitorCheckResultConditionInput
) {
  updateMonitorCheckResult(input: $input, condition: $condition) {
    id
    monitor_id
    subject_id
    interview_id
    initial_name
    initial_sex
    initial_age
    initial_address
    initial_marriage
    initial_children
    initial_job
    monitor_check_result_type
    submitted_text
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMonitorCheckResultMutationVariables,
  APITypes.UpdateMonitorCheckResultMutation
>;
export const deleteMonitorCheckResult = /* GraphQL */ `mutation DeleteMonitorCheckResult(
  $input: DeleteMonitorCheckResultInput!
  $condition: ModelMonitorCheckResultConditionInput
) {
  deleteMonitorCheckResult(input: $input, condition: $condition) {
    id
    monitor_id
    subject_id
    interview_id
    initial_name
    initial_sex
    initial_age
    initial_address
    initial_marriage
    initial_children
    initial_job
    monitor_check_result_type
    submitted_text
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMonitorCheckResultMutationVariables,
  APITypes.DeleteMonitorCheckResultMutation
>;
export const createChatData = /* GraphQL */ `mutation CreateChatData(
  $input: CreateChatDataInput!
  $condition: ModelChatDataConditionInput
) {
  createChatData(input: $input, condition: $condition) {
    id
    subject_id
    interview_id
    type
    file_type
    text
    file_url
    mentioned_monitor_id_list
    moderator_id
    monitor_id
    sort_index
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateChatDataMutationVariables,
  APITypes.CreateChatDataMutation
>;
export const updateChatData = /* GraphQL */ `mutation UpdateChatData(
  $input: UpdateChatDataInput!
  $condition: ModelChatDataConditionInput
) {
  updateChatData(input: $input, condition: $condition) {
    id
    subject_id
    interview_id
    type
    file_type
    text
    file_url
    mentioned_monitor_id_list
    moderator_id
    monitor_id
    sort_index
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateChatDataMutationVariables,
  APITypes.UpdateChatDataMutation
>;
export const deleteChatData = /* GraphQL */ `mutation DeleteChatData(
  $input: DeleteChatDataInput!
  $condition: ModelChatDataConditionInput
) {
  deleteChatData(input: $input, condition: $condition) {
    id
    subject_id
    interview_id
    type
    file_type
    text
    file_url
    mentioned_monitor_id_list
    moderator_id
    monitor_id
    sort_index
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteChatDataMutationVariables,
  APITypes.DeleteChatDataMutation
>;
export const createUsedResource = /* GraphQL */ `mutation CreateUsedResource(
  $input: CreateUsedResourceInput!
  $condition: ModelUsedResourceConditionInput
) {
  createUsedResource(input: $input, condition: $condition) {
    id
    subject_id
    interview_id
    type
    key
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUsedResourceMutationVariables,
  APITypes.CreateUsedResourceMutation
>;
export const updateUsedResource = /* GraphQL */ `mutation UpdateUsedResource(
  $input: UpdateUsedResourceInput!
  $condition: ModelUsedResourceConditionInput
) {
  updateUsedResource(input: $input, condition: $condition) {
    id
    subject_id
    interview_id
    type
    key
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUsedResourceMutationVariables,
  APITypes.UpdateUsedResourceMutation
>;
export const deleteUsedResource = /* GraphQL */ `mutation DeleteUsedResource(
  $input: DeleteUsedResourceInput!
  $condition: ModelUsedResourceConditionInput
) {
  deleteUsedResource(input: $input, condition: $condition) {
    id
    subject_id
    interview_id
    type
    key
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUsedResourceMutationVariables,
  APITypes.DeleteUsedResourceMutation
>;
export const createMonitorResource = /* GraphQL */ `mutation CreateMonitorResource(
  $input: CreateMonitorResourceInput!
  $condition: ModelMonitorResourceConditionInput
) {
  createMonitorResource(input: $input, condition: $condition) {
    id
    subject_id
    monitor_id
    interview_id
    sort_index
    file_name
    type
    url
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMonitorResourceMutationVariables,
  APITypes.CreateMonitorResourceMutation
>;
export const updateMonitorResource = /* GraphQL */ `mutation UpdateMonitorResource(
  $input: UpdateMonitorResourceInput!
  $condition: ModelMonitorResourceConditionInput
) {
  updateMonitorResource(input: $input, condition: $condition) {
    id
    subject_id
    monitor_id
    interview_id
    sort_index
    file_name
    type
    url
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMonitorResourceMutationVariables,
  APITypes.UpdateMonitorResourceMutation
>;
export const deleteMonitorResource = /* GraphQL */ `mutation DeleteMonitorResource(
  $input: DeleteMonitorResourceInput!
  $condition: ModelMonitorResourceConditionInput
) {
  deleteMonitorResource(input: $input, condition: $condition) {
    id
    subject_id
    monitor_id
    interview_id
    sort_index
    file_name
    type
    url
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMonitorResourceMutationVariables,
  APITypes.DeleteMonitorResourceMutation
>;
export const createInterviewResource = /* GraphQL */ `mutation CreateInterviewResource(
  $input: CreateInterviewResourceInput!
  $condition: ModelInterviewResourceConditionInput
) {
  createInterviewResource(input: $input, condition: $condition) {
    id
    subject_id
    interview_id
    sort_index
    chat_data_id
    type
    title
    description
    file_name
    url
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateInterviewResourceMutationVariables,
  APITypes.CreateInterviewResourceMutation
>;
export const updateInterviewResource = /* GraphQL */ `mutation UpdateInterviewResource(
  $input: UpdateInterviewResourceInput!
  $condition: ModelInterviewResourceConditionInput
) {
  updateInterviewResource(input: $input, condition: $condition) {
    id
    subject_id
    interview_id
    sort_index
    chat_data_id
    type
    title
    description
    file_name
    url
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateInterviewResourceMutationVariables,
  APITypes.UpdateInterviewResourceMutation
>;
export const deleteInterviewResource = /* GraphQL */ `mutation DeleteInterviewResource(
  $input: DeleteInterviewResourceInput!
  $condition: ModelInterviewResourceConditionInput
) {
  deleteInterviewResource(input: $input, condition: $condition) {
    id
    subject_id
    interview_id
    sort_index
    chat_data_id
    type
    title
    description
    file_name
    url
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteInterviewResourceMutationVariables,
  APITypes.DeleteInterviewResourceMutation
>;
export const createChatToken = /* GraphQL */ `mutation CreateChatToken(
  $input: CreateChatTokenInput!
  $condition: ModelChatTokenConditionInput
) {
  createChatToken(input: $input, condition: $condition) {
    id
    subject_id
    interview_id
    moderator_id
    monitor_id
    last_event_dates_id
    last_event_dates_updatedAt
    typing_chat_data_id
    read_index_id
    refreshed_at
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateChatTokenMutationVariables,
  APITypes.CreateChatTokenMutation
>;
export const updateChatToken = /* GraphQL */ `mutation UpdateChatToken(
  $input: UpdateChatTokenInput!
  $condition: ModelChatTokenConditionInput
) {
  updateChatToken(input: $input, condition: $condition) {
    id
    subject_id
    interview_id
    moderator_id
    monitor_id
    last_event_dates_id
    last_event_dates_updatedAt
    typing_chat_data_id
    read_index_id
    refreshed_at
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateChatTokenMutationVariables,
  APITypes.UpdateChatTokenMutation
>;
export const deleteChatToken = /* GraphQL */ `mutation DeleteChatToken(
  $input: DeleteChatTokenInput!
  $condition: ModelChatTokenConditionInput
) {
  deleteChatToken(input: $input, condition: $condition) {
    id
    subject_id
    interview_id
    moderator_id
    monitor_id
    last_event_dates_id
    last_event_dates_updatedAt
    typing_chat_data_id
    read_index_id
    refreshed_at
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteChatTokenMutationVariables,
  APITypes.DeleteChatTokenMutation
>;
export const createLastEventDates = /* GraphQL */ `mutation CreateLastEventDates(
  $input: CreateLastEventDatesInput!
  $condition: ModelLastEventDatesConditionInput
) {
  createLastEventDates(input: $input, condition: $condition) {
    id
    chat_created
    monitor_typing
    moderator_read
    monitor_read
    interviewer_announce
    chat_token_id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLastEventDatesMutationVariables,
  APITypes.CreateLastEventDatesMutation
>;
export const updateLastEventDates = /* GraphQL */ `mutation UpdateLastEventDates(
  $input: UpdateLastEventDatesInput!
  $condition: ModelLastEventDatesConditionInput
) {
  updateLastEventDates(input: $input, condition: $condition) {
    id
    chat_created
    monitor_typing
    moderator_read
    monitor_read
    interviewer_announce
    chat_token_id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLastEventDatesMutationVariables,
  APITypes.UpdateLastEventDatesMutation
>;
export const deleteLastEventDates = /* GraphQL */ `mutation DeleteLastEventDates(
  $input: DeleteLastEventDatesInput!
  $condition: ModelLastEventDatesConditionInput
) {
  deleteLastEventDates(input: $input, condition: $condition) {
    id
    chat_created
    monitor_typing
    moderator_read
    monitor_read
    interviewer_announce
    chat_token_id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLastEventDatesMutationVariables,
  APITypes.DeleteLastEventDatesMutation
>;
export const createLastChatSortIndex = /* GraphQL */ `mutation CreateLastChatSortIndex(
  $input: CreateLastChatSortIndexInput!
  $condition: ModelLastChatSortIndexConditionInput
) {
  createLastChatSortIndex(input: $input, condition: $condition) {
    id
    interview_id
    chat_sort_index
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLastChatSortIndexMutationVariables,
  APITypes.CreateLastChatSortIndexMutation
>;
export const updateLastChatSortIndex = /* GraphQL */ `mutation UpdateLastChatSortIndex(
  $input: UpdateLastChatSortIndexInput!
  $condition: ModelLastChatSortIndexConditionInput
) {
  updateLastChatSortIndex(input: $input, condition: $condition) {
    id
    interview_id
    chat_sort_index
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLastChatSortIndexMutationVariables,
  APITypes.UpdateLastChatSortIndexMutation
>;
export const deleteLastChatSortIndex = /* GraphQL */ `mutation DeleteLastChatSortIndex(
  $input: DeleteLastChatSortIndexInput!
  $condition: ModelLastChatSortIndexConditionInput
) {
  deleteLastChatSortIndex(input: $input, condition: $condition) {
    id
    interview_id
    chat_sort_index
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLastChatSortIndexMutationVariables,
  APITypes.DeleteLastChatSortIndexMutation
>;
export const createTypingChatData = /* GraphQL */ `mutation CreateTypingChatData(
  $input: CreateTypingChatDataInput!
  $condition: ModelTypingChatDataConditionInput
) {
  createTypingChatData(input: $input, condition: $condition) {
    id
    subject_id
    interview_id
    text
    moderator_id
    monitor_id
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTypingChatDataMutationVariables,
  APITypes.CreateTypingChatDataMutation
>;
export const updateTypingChatData = /* GraphQL */ `mutation UpdateTypingChatData(
  $input: UpdateTypingChatDataInput!
  $condition: ModelTypingChatDataConditionInput
) {
  updateTypingChatData(input: $input, condition: $condition) {
    id
    subject_id
    interview_id
    text
    moderator_id
    monitor_id
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTypingChatDataMutationVariables,
  APITypes.UpdateTypingChatDataMutation
>;
export const deleteTypingChatData = /* GraphQL */ `mutation DeleteTypingChatData(
  $input: DeleteTypingChatDataInput!
  $condition: ModelTypingChatDataConditionInput
) {
  deleteTypingChatData(input: $input, condition: $condition) {
    id
    subject_id
    interview_id
    text
    moderator_id
    monitor_id
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTypingChatDataMutationVariables,
  APITypes.DeleteTypingChatDataMutation
>;
export const createReadIndex = /* GraphQL */ `mutation CreateReadIndex(
  $input: CreateReadIndexInput!
  $condition: ModelReadIndexConditionInput
) {
  createReadIndex(input: $input, condition: $condition) {
    id
    subject_id
    interview_id
    moderator_id
    monitor_id
    read_index
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateReadIndexMutationVariables,
  APITypes.CreateReadIndexMutation
>;
export const updateReadIndex = /* GraphQL */ `mutation UpdateReadIndex(
  $input: UpdateReadIndexInput!
  $condition: ModelReadIndexConditionInput
) {
  updateReadIndex(input: $input, condition: $condition) {
    id
    subject_id
    interview_id
    moderator_id
    monitor_id
    read_index
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateReadIndexMutationVariables,
  APITypes.UpdateReadIndexMutation
>;
export const deleteReadIndex = /* GraphQL */ `mutation DeleteReadIndex(
  $input: DeleteReadIndexInput!
  $condition: ModelReadIndexConditionInput
) {
  deleteReadIndex(input: $input, condition: $condition) {
    id
    subject_id
    interview_id
    moderator_id
    monitor_id
    read_index
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteReadIndexMutationVariables,
  APITypes.DeleteReadIndexMutation
>;
export const createInterviewerAnnounce = /* GraphQL */ `mutation CreateInterviewerAnnounce(
  $input: CreateInterviewerAnnounceInput!
  $condition: ModelInterviewerAnnounceConditionInput
) {
  createInterviewerAnnounce(input: $input, condition: $condition) {
    id
    subject_id
    interview_id
    text
    sort_index
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateInterviewerAnnounceMutationVariables,
  APITypes.CreateInterviewerAnnounceMutation
>;
export const updateInterviewerAnnounce = /* GraphQL */ `mutation UpdateInterviewerAnnounce(
  $input: UpdateInterviewerAnnounceInput!
  $condition: ModelInterviewerAnnounceConditionInput
) {
  updateInterviewerAnnounce(input: $input, condition: $condition) {
    id
    subject_id
    interview_id
    text
    sort_index
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateInterviewerAnnounceMutationVariables,
  APITypes.UpdateInterviewerAnnounceMutation
>;
export const deleteInterviewerAnnounce = /* GraphQL */ `mutation DeleteInterviewerAnnounce(
  $input: DeleteInterviewerAnnounceInput!
  $condition: ModelInterviewerAnnounceConditionInput
) {
  deleteInterviewerAnnounce(input: $input, condition: $condition) {
    id
    subject_id
    interview_id
    text
    sort_index
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteInterviewerAnnounceMutationVariables,
  APITypes.DeleteInterviewerAnnounceMutation
>;
export const createNotificationEvent = /* GraphQL */ `mutation CreateNotificationEvent(
  $input: CreateNotificationEventInput!
  $condition: ModelNotificationEventConditionInput
) {
  createNotificationEvent(input: $input, condition: $condition) {
    id
    subject_id
    interview_id
    sort_index
    groups
    notification_event_type
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateNotificationEventMutationVariables,
  APITypes.CreateNotificationEventMutation
>;
export const updateNotificationEvent = /* GraphQL */ `mutation UpdateNotificationEvent(
  $input: UpdateNotificationEventInput!
  $condition: ModelNotificationEventConditionInput
) {
  updateNotificationEvent(input: $input, condition: $condition) {
    id
    subject_id
    interview_id
    sort_index
    groups
    notification_event_type
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateNotificationEventMutationVariables,
  APITypes.UpdateNotificationEventMutation
>;
export const deleteNotificationEvent = /* GraphQL */ `mutation DeleteNotificationEvent(
  $input: DeleteNotificationEventInput!
  $condition: ModelNotificationEventConditionInput
) {
  deleteNotificationEvent(input: $input, condition: $condition) {
    id
    subject_id
    interview_id
    sort_index
    groups
    notification_event_type
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteNotificationEventMutationVariables,
  APITypes.DeleteNotificationEventMutation
>;
export const createMail = /* GraphQL */ `mutation CreateMail(
  $input: CreateMailInput!
  $condition: ModelMailConditionInput
) {
  createMail(input: $input, condition: $condition) {
    id
    subject_id
    interview_id
    monitor_id
    heading
    message
    send_status
    notification_event_id
    sort_index
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMailMutationVariables,
  APITypes.CreateMailMutation
>;
export const updateMail = /* GraphQL */ `mutation UpdateMail(
  $input: UpdateMailInput!
  $condition: ModelMailConditionInput
) {
  updateMail(input: $input, condition: $condition) {
    id
    subject_id
    interview_id
    monitor_id
    heading
    message
    send_status
    notification_event_id
    sort_index
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMailMutationVariables,
  APITypes.UpdateMailMutation
>;
export const deleteMail = /* GraphQL */ `mutation DeleteMail(
  $input: DeleteMailInput!
  $condition: ModelMailConditionInput
) {
  deleteMail(input: $input, condition: $condition) {
    id
    subject_id
    interview_id
    monitor_id
    heading
    message
    send_status
    notification_event_id
    sort_index
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMailMutationVariables,
  APITypes.DeleteMailMutation
>;
export const createEmail = /* GraphQL */ `mutation CreateEmail(
  $input: CreateEmailInput!
  $condition: ModelEmailConditionInput
) {
  createEmail(input: $input, condition: $condition) {
    id
    monitor_id
    subject_id
    email
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEmailMutationVariables,
  APITypes.CreateEmailMutation
>;
export const updateEmail = /* GraphQL */ `mutation UpdateEmail(
  $input: UpdateEmailInput!
  $condition: ModelEmailConditionInput
) {
  updateEmail(input: $input, condition: $condition) {
    id
    monitor_id
    subject_id
    email
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEmailMutationVariables,
  APITypes.UpdateEmailMutation
>;
export const deleteEmail = /* GraphQL */ `mutation DeleteEmail(
  $input: DeleteEmailInput!
  $condition: ModelEmailConditionInput
) {
  deleteEmail(input: $input, condition: $condition) {
    id
    monitor_id
    subject_id
    email
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEmailMutationVariables,
  APITypes.DeleteEmailMutation
>;
export const createMonitorChatTokenLf = /* GraphQL */ `mutation CreateMonitorChatTokenLf($monitor_assign_id: ID!) {
  createMonitorChatTokenLf(monitor_assign_id: $monitor_assign_id) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMonitorChatTokenLfMutationVariables,
  APITypes.CreateMonitorChatTokenLfMutation
>;
export const updateMonitorAssignLf = /* GraphQL */ `mutation UpdateMonitorAssignLf($input: MonitorAssignLfInput) {
  updateMonitorAssignLf(input: $input) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMonitorAssignLfMutationVariables,
  APITypes.UpdateMonitorAssignLfMutation
>;
export const updateInterviewLf = /* GraphQL */ `mutation UpdateInterviewLf($chat_token_id: ID!, $input: InterviewLfInput) {
  updateInterviewLf(chat_token_id: $chat_token_id, input: $input) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateInterviewLfMutationVariables,
  APITypes.UpdateInterviewLfMutation
>;
export const createChatDataLf = /* GraphQL */ `mutation CreateChatDataLf($input: ChatDataLfInput, $chat_token_id: ID!) {
  createChatDataLf(input: $input, chat_token_id: $chat_token_id) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateChatDataLfMutationVariables,
  APITypes.CreateChatDataLfMutation
>;
export const createUsedResourceLf = /* GraphQL */ `mutation CreateUsedResourceLf(
  $input: UsedResourceLfInput
  $chat_token_id: ID!
) {
  createUsedResourceLf(input: $input, chat_token_id: $chat_token_id) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUsedResourceLfMutationVariables,
  APITypes.CreateUsedResourceLfMutation
>;
export const createMonitorResourceLf = /* GraphQL */ `mutation CreateMonitorResourceLf(
  $input: MonitorResourceLfInput
  $tmp_key: String!
  $chat_token_id: ID!
) {
  createMonitorResourceLf(
    input: $input
    tmp_key: $tmp_key
    chat_token_id: $chat_token_id
  ) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMonitorResourceLfMutationVariables,
  APITypes.CreateMonitorResourceLfMutation
>;
export const createInterviewResourceLf = /* GraphQL */ `mutation CreateInterviewResourceLf(
  $input: InterviewResourceLfInput
  $tmp_key: String!
  $chat_token_id: ID!
) {
  createInterviewResourceLf(
    input: $input
    tmp_key: $tmp_key
    chat_token_id: $chat_token_id
  ) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateInterviewResourceLfMutationVariables,
  APITypes.CreateInterviewResourceLfMutation
>;
export const updateTypingChatDataLf = /* GraphQL */ `mutation UpdateTypingChatDataLf(
  $chat_token_id: ID!
  $input: TypingChatDataLfInput
) {
  updateTypingChatDataLf(chat_token_id: $chat_token_id, input: $input) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTypingChatDataLfMutationVariables,
  APITypes.UpdateTypingChatDataLfMutation
>;
export const updateReadIndexLf = /* GraphQL */ `mutation UpdateReadIndexLf($chat_token_id: ID!, $input: ReadIndexLfInput) {
  updateReadIndexLf(chat_token_id: $chat_token_id, input: $input) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateReadIndexLfMutationVariables,
  APITypes.UpdateReadIndexLfMutation
>;
export const createInterviewerAnnounceLf = /* GraphQL */ `mutation CreateInterviewerAnnounceLf(
  $input: InterviewerAnnounceLfInput
  $chat_token_id: ID!
  $is_checked: Boolean
) {
  createInterviewerAnnounceLf(
    input: $input
    chat_token_id: $chat_token_id
    is_checked: $is_checked
  ) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateInterviewerAnnounceLfMutationVariables,
  APITypes.CreateInterviewerAnnounceLfMutation
>;
export const createMonitorCheckResultLf = /* GraphQL */ `mutation CreateMonitorCheckResultLf(
  $chat_token_id: ID!
  $input: MonitorCheckResultLfInput!
) {
  createMonitorCheckResultLf(chat_token_id: $chat_token_id, input: $input) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMonitorCheckResultLfMutationVariables,
  APITypes.CreateMonitorCheckResultLfMutation
>;
